import api from "src/api/axios";

const createNewBooking = async (input) => {
  return api.post(`/booking-orders`, input).then((result) => {
    return result.data;
  });
};

const updateBookingOrderData = async (data, id) => {
  return api.patch(`/booking-orders/${id}`, data).then((result) => {
    return result.data;
  });
};

const updateNewBookingOrderStatus = async (input, id) => {
  return api
    .patch(`/booking-orders/accept-reject/${id}`, input)
    .then((result) => {
      return result.data;
    });
};

const acceptMultiplePendingBookingOrders = (data) =>
  api.patch("/booking-orders/accept-reject-multiple", data);

const getBookingList = async (urlParams) => {
  const params = new URLSearchParams();
  for (const key in urlParams) {
    if (urlParams.hasOwnProperty(key)) {
      const value = urlParams[key];
      // Check if the value is not null or undefined or not empty string
      if (value) {
        params.append(key, value);
      }
    }
  }
  return api.get(`/booking-orders?${params}`).then((result) => {
    return result.data;
  });
};

const getSearchedBookingOrderList = async (urlParams, config) => {
  const params = new URLSearchParams();
  // Loop through each key-value pair in urlParams
  for (const key in urlParams) {
    if (urlParams.hasOwnProperty(key)) {
      const value = urlParams[key];
      // Check if the value is not null or undefined or not empty string
      if (value) {
        if (key === "sort" && Array.isArray(value)) {
          // If it's the sort parameter and it's an array, join it
          params.append(key, value.join(","));
        } else {
          params.append(key, value);
        }
      }
    }
  }
  return api.get(`/booking-orders?${params}`, config).then((result) => {
    return result.data;
  });
};

const getSingleBookingOrder = async (id) => {
  return api.get(`/booking-orders/${id}`).then((result) => {
    return result.data;
  });
};

const transferPackage = async (input) => {
  return api.post(`/transfer-package`, input).then((result) => {
    return result.data;
  });
};

const getBookingOrderLogs = async (id) => {
  return api.get(`/booking-orders/${id}/logs`).then((result) => {
    return result.data;
  });
};

const deleteBookingOrder = async (id, remarks) => {
  return api.delete(`/booking-orders/${id}`, { data: { remarks } }).then((result) => {
    return result.data;
  });
};

const getExportableBookingOrder = async (param) => {
  const params = new URLSearchParams();
  Object.keys(param).map((key) => {
    if (param[key]) {
      params.append(key, param[key]);
    }
  });
  return api.get(`/export-booking-orders/initiate?${params}`).then((result) => {
    return result.data;
  });
};

const getExportBatchSize = async (param) => {
  const params = new URLSearchParams();
  Object.keys(param).map((key) => {
    if (param[key]) {
      params.append(key, param[key]);
    }
  });
  return api
    .get(`/export-booking-orders/get-export-batch-size?${params}`)
    .then((result) => {
      return result.data;
    });
};

const getExportDataForBatch = async (param) => {
  const params = new URLSearchParams();
  Object.keys(param).map((key) => {
    if (param[key]) {
      params.append(key, param[key]);
    }
  });
  return api
    .get(`/export-booking-orders/get-export-data-for-batch?${params}`)
    .then((result) => {
      return result.data;
    });
};

const getExportProgress = async (sessionId) => {
  return api
    .get(`/export-booking-orders/retrieve-export-job/${sessionId}`)
    .then((result) => {
      return result.data;
    });
};

const getExportableBookingOrderForSuperAdmin = async () => {
  return api.get(`/booking-orders/export-super-admin`).then((result) => {
    return result.data;
  });
};

export {
  createNewBooking,
  updateBookingOrderData,
  getBookingList,
  getSingleBookingOrder,
  updateNewBookingOrderStatus,
  getSearchedBookingOrderList,
  transferPackage,
  getBookingOrderLogs,
  getExportableBookingOrder,
  getExportableBookingOrderForSuperAdmin,
  acceptMultiplePendingBookingOrders,
  getExportProgress,
  getExportBatchSize,
  getExportDataForBatch,
  deleteBookingOrder,
};
